/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Hétfo", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat", "Vasárnap"], t = ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"], s = "Évek", n = "Év", o = "Hónap", a = "Hét", c = "Napok", r = "Nap", d = "Mai nap", u = "Nincs esemény", m = "Egész nap", y = "Esemény törlese", p = "Esemény létrehozása", l = "dddd D MMMM YYYY", i = {
  weekDays: e,
  months: t,
  years: s,
  year: n,
  month: o,
  week: a,
  days: c,
  day: r,
  today: d,
  noEvent: u,
  allDay: m,
  deleteEvent: y,
  createEvent: p,
  dateFormat: l
};
export {
  m as allDay,
  p as createEvent,
  l as dateFormat,
  r as day,
  c as days,
  i as default,
  y as deleteEvent,
  o as month,
  t as months,
  u as noEvent,
  d as today,
  a as week,
  e as weekDays,
  n as year,
  s as years
};
